import React from 'react';
import { Alert, AlertTitle, Box, Typography } from '@mui/material';
import OfferForm from './components/OfferForm';
import { useFormContext } from 'react-hook-form';
import { WizardFormData } from './schemas';
import { useWizardData } from './hooks/useWizardData';

function OfferStep() {
  const { entryDomains, redirectDomains } = useWizardData();
  
  const { watch } = useFormContext<WizardFormData>();
  const offerUniqueId = watch('offerUniqueId');

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Offer Details
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Provide the basic information for your offer.
      </Typography>

      <Alert severity="info" sx={{ mb: 3 }}>
        <AlertTitle>Offer Unique ID</AlertTitle>
        <Typography variant="body2" color="text.secondary">
          {offerUniqueId}
        </Typography>
      </Alert>

      <OfferForm entryDomains={entryDomains} redirectDomains={redirectDomains} />
    </Box>
  );
}

export default OfferStep;
